import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';
import 'rxjs/add/operator/filter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import PerfectScrollbar from 'perfect-scrollbar';

declare var $ :any;

import { NgxUiLoaderService } from 'ngx-ui-loader';

import * as sha512 from 'crypto-js/sha512';

import { AuthenticationService } from '../../services/auth/auth.service';
import { Session } from '../../services/session/session.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private _router: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  public loginForm: any;
  public loginResponse: string = "";

  constructor(
    private ngxService: NgxUiLoaderService,
    public location: Location,
    private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private session: Session
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
        username   : ['', [Validators.required]],
        password: ['', Validators.required]
    });
  }

  ingresar(){
    this.loginResponse = "";
    var pass = sha512(this.loginForm.get("password").value).toString();

    var credentials = {
      usuario: this.loginForm.get("username").value,
      p: pass
    };

    this.authService.login(credentials, (error: any, result: any) : void => {
      if(error){
        this.loginResponse = error["mensaje"];
        return;
      }
      this.router.navigate(['/administrar/codigos']);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts